export default __webpack_public_path__ + "static/media/Beard_4_C3.60085e69.svg";